export const SET_CURRENT_ACTIVE_NAVIGATION_MENU =
  "SET_CURRENT_ACTIVE_NAVIGATION_MENU";
export const SET_CURRENT_EXPANDED_NAVIGATION_MENU =
  "SET_CURRENT_EXPANDED_NAVIGATION_MENU";
export const SET_LOADER_STATUS = "SET_LOADER_STATUS";
